import View from './view';
import {Props} from './model';
import {getFormValues, reduxForm} from 'redux-form';
import {Forms} from '../../../../../shared/models/forms';
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {profileApplicationsDictionariesSelector} from '../../../../../redux/selectors/profile';

const Form = reduxForm<any, any>({
  form: Forms.applicationsFilterForm,
  destroyOnUnmount: false,
})(View);

export const ApplicationsFilterVisuallyImpaired = (props: Props) => {
  const dictionaries = useSelector(profileApplicationsDictionariesSelector());
  const formData = useSelector((state) => getFormValues(Forms.applicationsFilterForm)(state));
  useEffect(() => {
    if (formData) {
      props.onSubmit(formData);
    }
  }, [formData]);
  return React.createElement(Form, {...props, ...dictionaries});
};
